export const ROUTES = {
  ROOT: "/",
  ATTACHMENTS: "/attachments",
  INBOX: "/inbox",
  ARCHIVED: "/archived",
  SETTING: "/setting",
  EXPLORE: "/explore",
  AUTH: "/auth",
  TICKERS: "/tickers",
  TICKER_DETAIL: "/tickers/:symbol",
  CHECKLIST_TEMPLATES: "/checklist-templates",
  JOURNAL_DETAIL: "/journals/:uid",
} as const;

export type RouteKey = keyof typeof ROUTES;
export type RoutePath = (typeof ROUTES)[RouteKey];
